module.exports = __webpack_public_path__ + "img/nlg.bef2a1cf.svg";